import { getCompressedFile } from "../shared/officeFileReader";
import { describeCompressedBytesUnavailable } from "../shared/compressedBytesSupport";

export const PPTX_MIME_TYPE =
  "application/vnd.openxmlformats-officedocument.presentationml.presentation";

/** The live presentation as .pptx bytes. All the hard parts are in the shared reader. */
export function getPresentationAsPptx(onProgress?: (fraction: number) => void): Promise<Blob> {
  return getCompressedFile(PPTX_MIME_TYPE, onProgress);
}

/**
 * Macro-enabled formats, blocked for the same reason as Excel's: getFileAsync has a
 * long-standing reputation for returning a macro-stripped package, and a Save that
 * silently drops someone's VBA is worse than one we declined to attempt.
 *
 * Only fires on an unambiguous extension, so an ordinary .pptx is never falsely
 * blocked.
 */
const MACRO_EXTENSIONS = [".pptm", ".potm", ".ppsm"];

function macroEnabledPresentation(): boolean {
  let url: string | undefined;
  try {
    url = Office.context?.document?.url ?? undefined;
  } catch {
    return false;
  }
  if (!url) return false;

  // A checked-out deck is opened from a signed URL, so drop the query before looking
  // at the extension -- the signature can contain anything.
  const path = url.split(/[?#]/)[0].toLowerCase();
  return MACRO_EXTENSIONS.some((extension) => path.endsWith(extension));
}

export function describeSaveUnavailable(): string | null {
  // Nothing to report on any mainstream platform: PowerPoint is the one host that can
  // return compressed bytes in a browser as well as on desktop and iPad.
  const platformReason = describeCompressedBytesUnavailable("powerpoint");
  if (platformReason) return platformReason;

  if (macroEnabledPresentation()) {
    return "Macro-enabled presentations cannot be saved from the add-in, because the macros would not survive the upload. Check this presentation in from Jylo in the browser instead.";
  }

  return null;
}
